module.exports = __webpack_public_path__ + "static/media/popup-image1.5e80af93.png";